<mat-progress-spinner
  class="w-[80px] h-[80px]"
  diameter="80"
  color="primary"
  mode="indeterminate">
</mat-progress-spinner>
